import { render, staticRenderFns } from "./AddFriends.vue?vue&type=template&id=f56caa12&scoped=true"
import script from "./AddFriends.vue?vue&type=script&lang=js"
export * from "./AddFriends.vue?vue&type=script&lang=js"
import style0 from "./AddFriends.vue?vue&type=style&index=0&id=f56caa12&lang=scss&scoped=true"
import style1 from "./AddFriends.vue?vue&type=style&index=1&id=f56caa12&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f56caa12",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f56caa12')) {
      api.createRecord('f56caa12', component.options)
    } else {
      api.reload('f56caa12', component.options)
    }
    module.hot.accept("./AddFriends.vue?vue&type=template&id=f56caa12&scoped=true", function () {
      api.rerender('f56caa12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/dashboard/AddFriends.vue"
export default component.exports